import type { Dayjs } from 'dayjs'

export type PDateRangePickerFastChoiceItem = {
  type: PDateRangePickerFastChoice
  name: string
}

/**
 * @deprecated
 */
export type PDateRangePickerModel = {
  from: Dayjs | null
  to: Dayjs | null
}

export enum PDateRangePickerFastChoice {
  YESTERDAY = 'yesterday',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  LAST_WEEK = 'last-week',
  THIS_WEEK = 'this-week',
  NEXT_WEEK = 'next-week',
  LAST_MONTH = 'last-month',
  THIS_MONTH = 'this-month',
  NEXT_MONTH = 'next-month',
  LAST_YEAR = 'last-year',
  THIS_YEAR = 'this-year',
  NEXT_YEAR = 'next-year',
}
